export const mensurationValues = {
  waterTreatment: {
    "1": {
      waterVolume: {
        jan: "",
        feb: "",
        mar: "",
        apr: "",
        may: "",
        jun: "",
        jul: "",
        aug: "",
        sep: "",
        oct: "",
        nov: "",
        dec: "",
      }
    },
    "2-1":  {
      aboveGroundWater: 0,
      subterraneanWater: 0,
      publicSupply: 0,
      rainWater: 0,
      reusedWater: 0,
    },
    "2-2": {
      description: ""
    },
    "3" : {
      aboveGroundWater: 0,
    }
  },
  measurementSectorization: {
    "1": "no",
    "1-1": "",
    "1-2": {
      E: "",
      M: "",
      A: "",
    },
    "1-3": "",
  },
  effluentTreatment: {
    "1": {
      effluentVolume: {
        jan: "",
        feb: "",
        mar: "",
        apr: "",
        may: "",
        jun: "",
        jul: "",
        aug: "",
        sep: "",
        oct: "",
        nov: "",
        dec: "",
      }
    },
    "2": "",
    "2-1": [],
    "2-2": {
      description: ""
    },
    "2-3": {
      efluentGerated: 0
    },
    "2-4": "",
    "2-5": {
      "DBO": "",
      "NAT": "",
    },
  },
  finalProduct: {
    "1": { products: ""},
    "2": "",
    "3": {
      quantityProduct: {
        jan: "",
        feb: "",
        mar: "",
        apr: "",
        may: "",
        jun: "",
        jul: "",
        aug: "",
        sep: "",
        oct: "",
        nov: "",
        dec: "",
      }
    },
  },
  input: {
    "1": "",
    "values": [
      {
        "1": "",
        "2": "",
        "3": "",
        "4": ""
      },
      {
        "1": "",
        "2": "",
        "3": "",
        "4": ""
      },
      {
        "1": "",
        "2": "",
        "3": "",
        "4": ""
      },
    ]
  },
  others: {
    "1"   : "",
    "2"   : "",
    "2-1" : "",
    "3"   : "",
    "4"   : "",
  }
};


// WEBPACK FOOTER //
// src/models/lib/mensurationValues.js